// // DashboardServices.js

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import DashboardServ from '../../services/externalServices/dashBoardServices';

// function DashboardServices() {
//     const [services, setServices] = useState([]);

//     useEffect(() => {
//         getServices();
//     }, []);

//     const getServices = async () => {
//         try {
//             // const response = await axios.get("http://localhost:8080/dashboard");
//             const response=await DashboardServ.getDashboardServices();
//             setServices(response);
//         } catch (error) {
//             console.error("Error while getting Dashboard Services ", error);
//         }
//     };

//     return (
//         <div className="container">
//             <nav>
//         <ol className="breadcrumb d-none d-lg-flex ms-3">
//           <li className="breadcrumb-item">
//             <i className="bi bi-house lh-1"></i>
//             <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>Home</Link>
//           </li>
//           <li className="breadcrumb-item opacity-50">CityConfig</li>
//         </ol>
//       </nav>
//             <h1 className="mt-3">Dashboard Services</h1>
//             <ul className="list-group">
//                 {services.map(service => (
//                     <li key={service._id} className="list-group-item">
//                         <Link to={`/dashboard/services/${service._id}`} className="text-decoration-none">{service.name}</Link>
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// }

// export default DashboardServices;

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardServ from '../../services/externalServices/dashBoardServices';
import { Card, CardContent, CardMedia, Typography, Grid, Chip, Container, Box } from '@mui/material';

function DashboardServices() {
    const [services, setServices] = useState([]);

    useEffect(() => {
        getServices();
    }, []);

    const getServices = async () => {
        try {
            const response = await DashboardServ.getDashboardServices();
            setServices(response);
        } catch (error) {
            console.error("Error while getting Dashboard Services ", error);
        }
    };

    return (
        <Container>
            <nav>
                <ol className="breadcrumb d-none d-lg-flex ms-3">
                    <li className="breadcrumb-item">
                        <i className="bi bi-house lh-1"></i>
                        <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>Home</Link>
                    </li>
                    <li className="breadcrumb-item opacity-50">services</li>
                </ol>
            </nav>
            <Typography variant="h4" gutterBottom className="mt-3">Dashboard Services</Typography>
            <Grid container spacing={3}>
                {services.map(service => (
                    <Grid item xs={12} sm={6} md={4} key={service._id}>
                        <Card sx={{ maxWidth: 300, mx: 'auto' }}>
                            <CardMedia
                                component="img"
                                alt={service.name}
                                height="140"
                                image={service.image_url}
                                sx={{ height: 100, objectFit: 'contain' }}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h6" component="div">
                                    {service.name}
                                </Typography>
                                {/* <Typography variant="body2" color="text.secondary">
                                    {service.description}
                                </Typography> */}
                                <Box mt={2}>
                                    <Chip
                                        label={service.active === "true" ? "Active" : "Inactive"}
                                        color={service.active === "true" ? "success" : "default"}
                                        size="small"
                                    />
                                    {service.tags.length > 0 && (
                                        <Chip
                                            label={service.tags.join(', ')}
                                            size="small"
                                            style={{ marginLeft: 8 }}
                                        />
                                    )}
                                </Box>
                                <Box mt={2}>
                                    <Link to={`/dashboard/services/${service._id}`} className="text-decoration-none">
                                        <Typography variant="body2" color="primary">
                                            View Details
                                        </Typography>
                                    </Link>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default DashboardServices;

